__turbopack_context__.v({
  "diversity": "jobTitleAndDiversity-module-scss-module__zIPh_q__diversity",
  "header": "jobTitleAndDiversity-module-scss-module__zIPh_q__header",
});
